import { Alert } from '../../components';
import {
  buyGiftCardPageQuery,
  buyGiftCardPageQuery_buyGiftCardPage
} from '../../core-types';
import { SystemConfig } from '../../lib/types';
import { useSystem } from '../../lib/core/useSystem';
import { BuyGiftCardsPayment2 } from './Payment2';

const BuyGiftCards = ({
  data,
  buyGiftCardPage
}: {
  systemConfig: SystemConfig;
  data: buyGiftCardPageQuery;
  buyGiftCardPage: buyGiftCardPageQuery_buyGiftCardPage;
}) => {
  const system = useSystem();
  if (!system.paymentProvider) {
    return <Alert>Payment provider not configured.</Alert>;
  }
  const { products } = data;
  if (!products || products.length === 0) {
    return <Alert>Currently we have no products for sale.</Alert>;
  }
  return (
    <BuyGiftCardsPayment2
      buyGiftCardPage={buyGiftCardPage}
      products={products}
    />
  );
};

export default BuyGiftCards;
